"use client";
import {
  tabs_default
} from "./chunk-RJGMUUQA.mjs";
import "./chunk-FUVFJH5A.mjs";
import "./chunk-XRBGUFFN.mjs";
import {
  useTabs
} from "./chunk-OJNRE73D.mjs";
import {
  tab_item_base_default
} from "./chunk-FXLYF44B.mjs";
export {
  tab_item_base_default as Tab,
  tabs_default as Tabs,
  useTabs
};
